exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-sticky{position:relative;height:100%;overflow:hidden}.cube-sticky-fixed{z-index:1;position:absolute;top:0;left:0;right:0}.cube-sticky-fixed-fade-enter,.cube-sticky-fixed-fade-leave-active{opacity:0}.cube-sticky-fixed-fade-enter-active,.cube-sticky-fixed-fade-leave-active{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}", ""]);

// exports
